import { useState } from "react";
import { Send } from "lucide-react";

export const Signal = ({ isLight }) => {
  const [formData, setFormData] = useState({ subject: '', message: '' });

  const clearSubj = () => {
    setFormData(prev => ({...prev, subject:''}));
  };

  const clearMsg = () => {
    setFormData(prev => ({...prev, message:''}));
  };
  // Constructed mailto URL
  const mailtoUrl = `mailto:0xdagcorp@gmail.com?subject=${encodeURIComponent(formData.subject || 'PhishGuard Signal')}&body=${encodeURIComponent(formData.message)}`;

  return (
    <div className={`rounded-lg p-10 border animate-in backdrop-blur-md ${
      isLight ? 'bg-white/80 border-slate-200' : 'bg-[#111114]/80 border-white/10'
    }`}>
      <h2 className={`text-xs font-black mb-4 uppercase tracking-[0.3em] ${isLight ? 'text-slate-900' : 'text-slate-50'}`}>We'd love to hear from you ! ❤️</h2>
      
      <div className="space-y-8 mt-10">
        <div className="relative group">
           <input 
          type="text" 
          placeholder="SUBJECT: OBSERVATION / FEEDBACK" 
          value={formData.subject}
          onChange={(e) => setFormData({...formData, subject: e.target.value})}
          className={`w-full bg-transparent border-b py-4 text-xs font-mono outline-none transition-all ${
            isLight ? 'border-slate-200 text-slate-900 focus:border-slate-900' : 'border-white/5 text-white focus:border-white'
          }`} 
        />
        {formData.subject && (
              <button 
                onClick={clearSubj}
                className={`absolute right-0 top-1/2 -translate-y-1/2 p-2 ${isLight ? 'hover:text-slate-300' : 'hover:text-white'} text-slate-500 transition-colors`}
                title="Clear input"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-current stroke-2">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>
            )}
        </div>
       
       <div className='relative group'>
        <textarea 
          placeholder="DESCRIBE RESPONSE / THOUGHTS... " 
          rows={1}
          value={formData.message}
          onChange={(e) => setFormData({...formData, message: e.target.value})}
          className={`w-full bg-transparent border-b py-4 text-xs font-mono outline-none transition-all resize-none ${
            isLight ? 'border-slate-200 text-slate-900 focus:border-slate-900' : 'border-white/5 text-white focus:border-white'
          }`} 
        />
        {formData.message && (
              <button 
                onClick={clearMsg}
                className="absolute right-0 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-white transition-colors"
                title="Clear input"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-current stroke-2">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>
            )}
       </div>
        
        
        <a 
          href={mailtoUrl}
          className={`flex items-center justify-center gap-3 w-full py-5 border text-[9px] font-black uppercase tracking-[0.4em] transition-all ${
            isLight 
              ? 'border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white' 
              : 'border-white text-white hover:bg-white hover:text-black'
          }`}
        >
          <Send size={12} />
          Submit
        </a>

        <div className="text-center pt-4">
          <p className={`text-[8px] uppercase font-bold tracking-widest ${isLight ? 'text-slate-400' : 'text-slate-500'}`}>
            Manual Destination: <span className="underline italic">0xdagcorp@gmail.com</span>
          </p>
        </div>
      </div>
    </div>
  );
};
